import { environment } from '../config/cabinet-environment';

/**
 * Visibility rule for the CAD add-in surfaces — the user and admin "CAD Add-ins"
 * pages and the CAD Attributes pushed in by an add-in.
 *
 * | build              | visible |
 * |--------------------|---------|
 * | cloud dev / local  | yes     |
 * | cloud prod         | no      |
 *
 * Desktop registers neither the routes nor the cabinet sidebar, so this rule is
 * a cloud-only concern; the desktop Plugin API pipe server is unaffected.
 */
export function canUsePluginTools(): boolean {
  return !environment.PRODUCTION;
}
